var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBitfinextLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0210686 16.3029C-0.197681 12.7629 1.28982 8.82794 4.35107 5.76669C11.0086 -0.890813 24.8736 0.0416876 24.9523 0.0479376C24.9148 0.102938 14.7786 14.7979 2.76733 16.1729C1.83983 16.2792 0.922319 16.3217 0.0210686 16.3029Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.42773 20.828C1.77148 21.3755 2.1765 21.8867 2.64525 22.3555C6.75525 26.4655 14.1827 25.7017 19.234 20.6505C25.9115 13.973 24.9527 0.0479736 24.9527 0.0479736C24.9165 0.130474 17.6502 16.4167 6.10274 19.9692C4.53524 20.4517 2.96398 20.7317 1.42773 20.828Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitfinextLogo);
export default __webpack_public_path__ + "static/media/bitfinext-logo.32ec724c.svg";
export { ForwardRef as ReactComponent };